<script setup>
import { formatPercentage } from '@js/utils/formatter';

const {
    percentage,
    align,
    withDecimals = false,
    withPlus = false,
} = defineProps({
    percentage: {
        type: [Number],
        required: true,
    },
    align: {
        type: String,
        default: 'left',
        required: false,
    },
    withDecimals: {
        type: Boolean,
        required: false,
    },
    type: {
        type: String,
        required: false,
    },
    withPlus: {
        type: Boolean,
        required: false,
    },
});
</script>

<template>
    <div
        class="flex h-full items-center p-4 text-lg font-bold whitespace-nowrap"
        :class="{
            'justify-start': align === 'left',
            'justify-center text-center': align === 'center',
            'justify-end': align === 'right',
            'text-red-500': type === 'danger',
            'text-green-500': type === 'success',
        }"
    >
        {{ formatPercentage(percentage, withPlus, withDecimals) }}
    </div>
</template>
